import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useLocalSettings } from '@/lib/contexts/LocalSettingsContext';
const STORAGE_KEY = 'demandFeed.shuffle';
const DEFAULT_SHUFFLE = true;

/**
 * Reactive shuffle preference for the inspiration feed, persisted via
 * LocalSettings (localStorage). Defaults to shuffled. Initializes to the stored
 * value after mount so SSR and first client render match (avoids a hydration
 * mismatch), then keeps state and storage in sync.
 */
export function useDemandFeedShuffle(t0) {
  const $ = _c(12);
  const defaultShuffle = t0 === undefined ? DEFAULT_SHUFFLE : t0;
  const settings = useLocalSettings();
  const [shuffle, setShuffleState] = useState(defaultShuffle);
  let t1;
  let t2;
  if ($[0] !== settings) {
    t1 = () => {
      const stored = settings.get(STORAGE_KEY);
      if (typeof stored === "boolean") {
        setShuffleState(stored);
      }
    };
    t2 = [settings];
    $[0] = settings;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== settings) {
    t3 = next => {
      setShuffleState(next);
      settings.set(STORAGE_KEY, next);
    };
    $[3] = settings;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setShuffle = t3;
  let t4;
  if ($[5] !== setShuffle || $[6] !== shuffle) {
    t4 = () => {
      setShuffle(!shuffle);
    };
    $[5] = setShuffle;
    $[6] = shuffle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const toggleShuffle = t4;
  let t5;
  if ($[8] !== setShuffle || $[9] !== shuffle || $[10] !== toggleShuffle) {
    t5 = {
      shuffle,
      setShuffle,
      toggleShuffle
    };
    $[8] = setShuffle;
    $[9] = shuffle;
    $[10] = toggleShuffle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}